/* eslint-disable react/prop-types */
/* eslint-disable class-methods-use-this */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import root from 'window-or-global';
import HREFS from 'common/consts/hrefs';
import { NAV_HEIGHT } from 'common/consts/navigation';
import ANCHOR from 'common/consts/anchor';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';
import ButtonsSection from './ButtonsSection';
import TagASignIn from './TagASignIn';
import TagAGetTheApp from './TagAGetTheApp';

@inject('windowStore', 'coreStore', 'productsStore', 'navigationStore', 'appStore')
@observer
class Buttons extends Component {
  constructor(props) {
    super(props);
    this.buttonsSectionRef = React.createRef();
  }

  componentDidMount() {
    this.setButtonsSectionWidth();
  }

  componentDidUpdate() {
    this.setButtonsSectionWidth();
  }

  @Bind
  setButtonsSectionWidth() {
    const { navigationStore } = this.props;

    if (this.buttonsSectionRef && this.buttonsSectionRef.current) {
      const buttonsSectionWidth = this.buttonsSectionRef.current.getBoundingClientRect().width;
      navigationStore.setButtonsSectionWidth(buttonsSectionWidth);
    }
  }

  scrollToForm(formRef) {
    const {
      windowStore: {
        isOnMobile,
      },
    } = this.props;

    if (isOnMobile) {
      setTimeout(() => formRef.scrollIntoView({ block: 'start' }), 1000);
    } else {
      const offsetTop = formRef.getBoundingClientRect().top + root.scrollY;
      root.scroll({ top: offsetTop - NAV_HEIGHT, behavior: 'smooth' });
    }
  }

  render() {
    const {
      onItemClick,
      windowStore: {
        isOnTablet,
      },
      coreStore: {
        translations,
      },
      appStore: {
        currentLanguage,
      },
    } = this.props;

    return (
      <ButtonsSection
        innerRef={this.buttonsSectionRef}
        onClick={() => onItemClick()}
      >
        {isOnTablet && (
          <TagASignIn
            text={translations.NAVIGATION_SIGN_IN}
            href={HREFS.SIGN_IN}
          />
        )}
        <TagAGetTheApp
          to={ANCHOR.CONTACT_FORM[currentLanguage]}
        >
          {translations.NAVIGATION_GET_THE_APP}
        </TagAGetTheApp>
      </ButtonsSection>
    );
  }
}
Buttons.propTypes = {
  onItemClick: PropTypes.func,
};
Buttons.defaultProps = {
  onItemClick: () => {},
};

export default withRouter(Buttons);



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Buttons/index.jsx